/**
 * CANvms API Client — Singleton
 *
 * Single axios instance shared by CANvmsAPI.ts and incidents.ts.
 * Replaces the per-call createCanvmsApiInstance() pattern.
 *
 * - baseURL uses a relative path so the browser's current origin
 *   is used automatically (no hardcoded localhost).
 * - 401/403 responses dispatch a custom event so any listener
 *   (e.g. CANvisionProvider) can prompt re-authentication.
 */

import axios from 'axios';

const canvmsApi = axios.create({
  baseURL: '/api3.2/canvms',
  timeout: 30000,
  withCredentials: true,
});

// Session-expiry interceptor (fixes Bug #3 & Bug #6)
canvmsApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      window.dispatchEvent(new CustomEvent('canvision:session-expired'));
    }
    return Promise.reject(error);
  }
);

export default canvmsApi;
